import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";

import {
    ModeOfSaleRow,
    setTicketKitchenModeSale,
    storeKitchenTicketType,
} from "@components/Common/PrinterSetting/stores";

import { PrinterRowData, PrinterAppId } from "../../types";
import { SalesModeApiItem } from "../../hooks/salesModesHelper";

import "../index.css";

type PrintKitchenTicketType = {
    rowData: PrinterRowData;
    salesModesData: SalesModeApiItem[];
    appId: PrinterAppId;
};

function PrintKitchenTicket({
    rowData,
    salesModesData,
    appId,
}: PrintKitchenTicketType) {
    const { t } = useTranslation();
    const { ticketKitchenModeSale } = useSnapshot(storeKitchenTicketType);
    const [salesModes, setSalesModes] = React.useState<ModeOfSaleRow[]>([]);

    const fetchModeOfSale = React.useCallback(() => {
        const kitchenTicket =
            typeof rowData["Kitchen_ticket"] === "object"
                ? rowData["Kitchen_ticket"]
                : undefined;
        const saleModes = (salesModesData ?? []).map((saleMode) => {
            const isApplicable =
                appId === "" || saleMode.support_vente.includes(appId);
            return {
                saleSupports: isApplicable
                    ? [{ designation: saleMode["Mode of sale"], state: true }]
                    : [],
            };
        });
        let sales: ModeOfSaleRow[] = [];
        const salesModes: string[] = [];
        let rowDataSales: ModeOfSaleRow[] = [];

        const salesSupportMode: string[] = [];
        if (kitchenTicket?.ticketKitchenModeSale !== undefined) {
            for (let element of kitchenTicket
                ?.ticketKitchenModeSale ?? []) {
                rowDataSales.push(element);
            }
        }
        saleModes !== undefined &&
            saleModes.forEach((el) => {
                el.saleSupports.forEach((elt) => {
                    if (elt !== undefined) {
                        salesSupportMode.push(elt.designation);
                        rowDataSales = rowDataSales.filter(
                            (el) => el.designation !== elt.designation
                        );
                    }
                });
            });
        saleModes !== undefined &&
            saleModes.forEach((el) => {
                if (
                    kitchenTicket?.ticketKitchenModeSale !==
                    undefined
                ) {
                    for (let element of kitchenTicket
                        ?.ticketKitchenModeSale ?? []) {
                        salesModes.push(element.designation);
                        sales.push(element);
                    }
                    el.saleSupports.forEach((elt) => {
                        if (
                            elt !== undefined &&
                            !salesModes.includes(elt.designation)
                        ) {
                            sales.push(elt);
                        }
                    });
                } else {
                    el.saleSupports.forEach((elt) => {
                        if (
                            kitchenTicket?.ticketKitchenModeSale ===
                                undefined ||
                            kitchenTicket?.ticketKitchenModeSale
                                ?.length === 0
                        ) {
                            elt !== undefined && sales.push(elt);
                        }
                    });
                }
            });
        sales = [...new Set(sales)];
        for (let sale of rowDataSales) {
            sales = sales.filter((el) => el.designation !== sale.designation);
        }
        setSalesModes(sales);
    }, [salesModesData, rowData,appId]);
    useEffect(() => {
        fetchModeOfSale();
    }, [fetchModeOfSale]);
    useEffect(() => {
        setTicketKitchenModeSale(salesModes);
    }, [salesModes]);
    const handleStateSortedVisibilityChange = (
        item: ModeOfSaleRow,
        index: number
    ) => {
        const items = { ...item };
        items.state = !items.state;
        const newVisibility: ModeOfSaleRow[] = JSON.parse(
            JSON.stringify(ticketKitchenModeSale)
        );
        newVisibility[index].state = items.state;
        setTicketKitchenModeSale(newVisibility);
    };

    return (
        <div>
            <div className="d-flex p-2">
                <div>
                    <b>
                        {t(
                            "Print the kitchen ticket according to the mode of sale"
                        )}
                    </b>
                </div>
            </div>
            <div className="d-flex  align-items-center d-flex flex-wrap">
                {ticketKitchenModeSale.map(
                    (modeOfSale: ModeOfSaleRow, index: number): JSX.Element => (
                        <div
                            key={modeOfSale.designation}
                            className="text-danger row b-2 align-items-center"
                        >
                            <div
                                className="d-flex col-4"
                                style={{ color: "#212529 " }}
                            >
                                <div className="px-1">
                                    <h6 style={{ width: "87px" }}>
                                        {modeOfSale.designation}
                                    </h6>
                                </div>
                                <div className="mr-2">
                                    <ReactSwitch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        handleDiameter={26}
                                        offColor="#f7b4b8"
                                        offHandleColor="#E30613"
                                        checked={modeOfSale.state}
                                        onChange={() => {
                                            handleStateSortedVisibilityChange(
                                                modeOfSale,
                                                index
                                            );
                                        }}
                                        onColor="#c2eddd"
                                        onHandleColor="#34C38F"
                                        width={55}
                                        height={20}
                                        className="fed_icn_FRmodeOfSales"
                                        aria-label={t(modeOfSale.designation)}
                                        data-testid={`printer-setting-kitchen-mode-${index}-switch`}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
}

export default PrintKitchenTicket;
